import React from 'react';

export default function ButterflyWingsFiveSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,35.42 17.97,34.31 17.97,4.58 38.0,5.69" fill="#502930" />
      <polygon points="17.61,34.31 2.0,35.42 2.0,5.69 17.61,4.58" fill="#502930" />
    </svg>
  );
}
